import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import Iconify from '../../../components/iconify';

const AddOperator = ({ hidden }) => {
  if (hidden) return null;
  return (
    <Button
      component={Link}
      to="add-operator"
      variant="text"
      startIcon={<Iconify icon="healthicons:call-centre-outline" width={20} />}
      sx={{ color: 'primary.main', fontWeight: 500 }}
    >
      Operator qo'shish
    </Button>
  );
};

export default AddOperator;
